export const imageOrientation = (image) => {
  const dimensions = image && image.dimensions;

  if (!dimensions) {
    return "portrait";
  }

  return dimensions.width > dimensions.height ? "landscape" : "portrait";
};
